var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderColumn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 15.3333L13.3333 4.66667C13.3333 4.29867 13.632 4 14 4L15.3333 4C15.7013 4 16 4.29867 16 4.66667L16 15.3333C16 15.7013 15.7013 16 15.3333 16L14 16C13.632 16 13.3333 15.7013 13.3333 15.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66671 9.66667L8.66671 4.33333C8.66671 4.14933 8.96537 4 9.33337 4L10.6667 4C11.0347 4 11.3334 4.14933 11.3334 4.33333L11.3334 9.66667C11.3334 9.85067 11.0347 10 10.6667 10L9.33337 10C8.96537 10 8.66671 9.85067 8.66671 9.66667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99996 15.3333L3.99996 4.66667C3.99996 4.29867 4.29863 4 4.66663 4L5.99996 4C6.36796 4 6.66663 4.29867 6.66663 4.66667L6.66663 15.3333C6.66663 15.7013 6.36796 16 5.99996 16L4.66663 16C4.29863 16 3.99996 15.7013 3.99996 15.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderColumn);
export default ForwardRef;